import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCertificationListAPI } from "../../apiConfig/apiCall";

export const getCertificationList = createAsyncThunk('getComplianceList', async () => {
    const response = await getCertificationListAPI();
    return response.data;
});